/**
 * Generated by orval 🍺
 * Do not edit manually.
 * PSPulse API
 * South Tyrol Pronto Soccorso queue data — with a memory: history, trends, and forecasts. Data source: the CC0 PS_Queue feed from Open Data Südtirol (https://dati.retecivica.bz.it/). Tier-1 read endpoints (live overview, per-hospital history, day×hour heatmap, estimated wait) are live; the estimated-wait figures are deliberately rough, drain-rate estimates.
 * OpenAPI spec version: 1.0.0
 */

/**
 * Qualitative confidence in a wait estimate.
 */
export type WaitConfidence = typeof WaitConfidence[keyof typeof WaitConfidence];


export const WaitConfidence = {
  none: 'none',
  low: 'low',
  medium: 'medium',
  high: 'high',
} as const;
